import {
  AGREEMENT_TOGGLE,
  AGREEMENTS_SET
}
  from 'src/app/redux/actions/registration/experience/experienceAgreements';
import mapCheckedAgreements from 'src/app/api/mapCheckedAgreements';


const initialState = {
  agreements: []
};


const experienceAgreementsReducer = (state = initialState, action = {}) => ({
  [AGREEMENTS_SET]: () => ({ ...state, ...action.payload }),
  [AGREEMENT_TOGGLE]: () => ({
    ...state,
    agreements: state.agreements
      .map(mapCheckedAgreements(action))
  })
}[action.type] || (() => state))();


export default experienceAgreementsReducer;
